import {
  AbstractControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import { Impresa } from '../models/impresa';
import { typedEntries } from '../../_utils/typed-entries';
import { nonCrifKeys } from './non-crif-fields';

type FormModel<T> = Record<keyof T, AbstractControl>;

export const crifValidator = (impresa: Impresa): ValidatorFn => {
  return (
    formGroup: FormGroup<FormModel<Impresa>>
  ): ValidationErrors | null => {
    let nonCrifFields: Readonly<(keyof Impresa)[]> =
      impresa?.tipoSoggetto !== 'SC'
        ? [...nonCrifKeys, 'fatturatoUltimoAnno']
        : nonCrifKeys;

    let crifEntries = typedEntries(formGroup.controls).filter(
      ([key, ctrl]) => !nonCrifFields.includes(key)
    );
    let invalidFields = crifEntries
      .filter(([key, ctrl]) => ctrl.invalid)
      .map(([key, ctrl]) => key)
      .join(', ');

    if (invalidFields.length > 0) {
      // Return validation error if at least one field is invalid
      return { crifError: invalidFields };
    }

    // Return null if the validation passes
    return null;
  };
};
